import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject, type OnDestroy } from '@angular/core';
import { PorscheDesignSystemModule, ToastManager } from '@porsche-design-system/components-angular';
import { BehaviorSubject, distinctUntilChanged, tap } from 'rxjs';
import { SubSink } from 'subsink';
import type { InventoryLocation } from '../../../shared/models/api/inventory-location.model';
import { InventoryLocationService } from '../../../shared/services/api/inventory-location.service';

@Component({
  selector: 'opa-inventory-location-delete',
  imports: [CommonModule, PorscheDesignSystemModule],
  templateUrl: './inventory-location-delete.component.html',
  styleUrl: './inventory-location-delete.component.scss',
})
export class InventoryLocationDeleteComponent implements OnDestroy {
  private readonly inventoryLocationService = inject(InventoryLocationService);
  private readonly toastManager = inject(ToastManager);

  @Input({ required: true }) open = false;
  @Input({ required: true }) inventoryLocation: InventoryLocation | undefined = undefined;
  @Output() dismiss = new EventEmitter<InventoryLocation | undefined>();

  private readonly subSink = new SubSink();
  private readonly submitting = new BehaviorSubject(false);
  readonly submitting$ = this.submitting.pipe(distinctUntilChanged());

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  close(inventoryLocation?: InventoryLocation): void {
    this.dismiss.emit(inventoryLocation);
  }

  submit(): void {
    const inventorylocation = this.inventoryLocation;
    if (!inventorylocation) return;

    this.submitting.next(true);
    this.subSink.sink = this.inventoryLocationService
      .deleteInventoryLocation(inventorylocation.id)
      .pipe(
        tap({
          next: () => {
            this.toastManager.addMessage({
              text: `Location ${inventorylocation.name} deleted`,
              state: 'success',
            });
            this.submitting.next(false);
            this.dismiss.emit(inventorylocation);
          },
          error: () => this.submitting.next(false),
        }),
      )
      .subscribe();
  }
}
